import React from "react";
import "./TermsHeader.css";

const TermsHeader = () => {
  return (
    <section className="TermsHeader-container">
      <div className="TermsHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="TermsHeader-title">Our Terms And Conditions</h1>
          <div className="TermsHeader-breadcrumb">
            <button className="btn btn-primary">
              Home - Terms And Conditions
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsHeader;
